<template>
  <section class="section">
    <div class="container is-fluid">
      <h1 class="title is-1">History</h1>

      <section v-if="loading" class="loading-section">
        <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="true"></b-loading>
      </section>
      <section v-else-if="hasHistoryPost">
        <div class="columns">
          <div v-html="history.body" class="column is-three-fifths is-offset-one-fifth has-text-left" />
        </div>
      </section>
      <section v-else>
        <p>
          There is no history post yet. Check back later
        </p>
      </section>
    </div>
  </section>
</template>

<script>
import _ from 'lodash';
import HistoryAPI from '@/services/api/History';

export default {
  name: 'HistoryPage',
  data() {
    return {
      loading: true,
      history: {},
      hasHistoryPost: false,
    };
  },
  mounted() {
    HistoryAPI.getHistoryPost()
      .then(history => {
        if (!_.isEmpty(history)) {
          this.history = history[0];
          this.hasHistoryPost = true;
        } else {
          this.history = {};
          this.hasHistoryPost = false;
        }
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped>
</style>
